import { STRIPE_KEY } from "../constant/app.data.constant";

export default class PaymentHelpers {
    static paymentDataRequest(paymentData) {
        try {
            let stripeDetails = this.stripeDetails(true);
            let lineItems = [];
            if(!!paymentData && !!paymentData.lineItems)
                lineItems = paymentData.lineItems;
            // 1) Request a payment token for your payment provider
            const tokenizationSpecification = {
                type: "PAYMENT_GATEWAY",
                // stripe payment gateway
                parameters: {
                    gateway: "stripe",
                    "stripe:version": stripeDetails.version,
                    "stripe:publishableKey": stripeDetails.publishableKey,
                },
            };

            // 2) Describe your allowed payment methods
            const baseCardPaymentMethod = {
                type: "CARD",
                parameters: {
                    allowedAuthMethods: ["PAN_ONLY", "CRYPTOGRAM_3DS"],
                    allowedCardNetworks: ["AMEX", "DISCOVER", "INTERAC", "JCB", "MASTERCARD", "VISA"],
                },
            };

            const cardPaymentMethod = {
                ...baseCardPaymentMethod,
                tokenizationSpecification: tokenizationSpecification,
            };

            // 3) Transaction info
            const transactionInfo = {
                totalPriceStatus: "FINAL",
                totalPriceLabel: "Total",
                totalPrice: paymentData.transactiondetails.total_amount.toFixed(2),
                currencyCode: paymentData.transactiondetails.currency.toUpperCase(),
                countryCode: paymentData.transactiondetails.countryCode,
                displayItems: (!!lineItems && lineItems.length > 0) ? lineItems :[
                    {
                        label: paymentData.transactiondetails.transaction_description,
                        type: "LINE_ITEM",
                        price: paymentData.transactiondetails.total_amount.toFixed(2),
                    },
                ],
            };

            // 4) merchant info
            const merchantInfo = {
                // A Google merchant identifier issued after your website is approved by Google
                merchantId: "16857882227307232005",
                merchantName: paymentData.payee, // 'Example Merchant',
            };

            // 5) Address is pending

            //Create a PaymentDataRequest object
            const paymentDataRequest = {
                apiVersion: 2,
                apiVersionMinor: 0,
                allowedPaymentMethods: [cardPaymentMethod],
                merchantInfo: merchantInfo,
                transactionInfo: transactionInfo,
                emailRequired: true,
                callbackIntents: ["SHIPPING_ADDRESS", "PAYMENT_AUTHORIZATION"], //"SHIPPING_OPTION", "SHIPPING_ADDRESS",
                shippingAddressRequired: true,
                // // shippingOptionRequired : true,
                shippingAddressParameters: {
                    phoneNumberRequired: true,
                },
            };

            return paymentDataRequest;
        } catch (error) {
            return null;
        }
    }

    static stripeDetails() {
        try {
            let stripeDetails = STRIPE_KEY;
            return stripeDetails;
        } catch (error) {
            return null;
        }
    }
}